<template>
  <div class="favorites-container infinite-list-page">
    <!-- <h4 class="section-title">我的收藏</h4> -->

    <div class="infinite-list-page__body">
      <div class="infinite-list-page__content">
        <div v-if="loading && displayFavorites.length === 0" class="infinite-initial-loading">
          加载中...
        </div>

        <!-- 收藏列表 -->
        <div v-else-if="displayFavorites.length > 0" class="favorite-list">
          <div
            class="favorite-item"
            v-for="item in displayFavorites"
            :key="item.id"
            @click="goToComicDetail(item.id)"
          >
            <img :src="item.image" alt="收藏封面" class="favorite-image" />
            <div class="favorite-details">
              <h5 class="favorite-title">{{ item.title }}</h5>
              <!-- 漫画主题 -->
              <div class="favorite-themes" v-if="item.themes.length > 0">
                <span class="theme-dot"></span>
                <span class="theme-text">
                  {{ item.themes.join(' / ') }}
                </span>
              </div>
              <p class="favorite-description">{{ item.description }}</p>
            </div>
          </div>
        </div>

        <!-- 无收藏记录 -->
        <div v-else class="empty-favorites">
          <el-empty description="暂无收藏漫画"></el-empty>
        </div>

        <div
          v-if="isMobile && displayFavorites.length > 0"
          ref="favoritesSentinel"
          class="infinite-sentinel"
          aria-hidden="true"
        />
        <p v-if="isMobile && loadingMore" class="infinite-loading-hint">加载中...</p>
      </div>
      <div
        v-if="showInfiniteEndTip"
        class="infinite-list-page__spacer"
        aria-hidden="true"
      />
    </div>

    <p v-if="showInfiniteEndTip" class="infinite-end-tip">
      <span class="infinite-end-tip-text">我也是有底线的</span>
    </p>

    <!-- 分页（仅桌面端） -->
    <div v-if="!isMobile && totalItems > 0" class="pagination">
      <button
        class="page-button"
        @click="previousPage"
        :disabled="currentPage === 1"
      >
        上一页
      </button>
      <span class="page-info">
        第 {{ currentPage }} 页 / 共 {{ totalPages }} 页（共 {{ totalItems }} 条）
      </span>
      <button
        class="page-button"
        @click="nextPage"
        :disabled="currentPage === totalPages"
      >
        下一页
      </button>
    </div>
  </div>
</template>

<script setup>
import { useUserFavorites } from '@/features/user/composables/useUserFavorites'

const {
  loading,
  loadingMore,
  isMobile,
  favoritesSentinel,
  displayFavorites,
  showInfiniteEndTip,
  currentPage,
  totalPages,
  totalItems,
  goToComicDetail,
  nextPage,
  previousPage,
} = useUserFavorites()
</script>

<style scoped src="@/features/user/styles/operationArea/UserFavorites.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
